import React from "react";
import { D, Chip, namaKota as KOTA } from "../../ui";
import { hitungMundur } from "./BandaraCard";

const STATUS = { dijadwalkan: ["blue", "Dijadwalkan"], terbang: ["green", "Terbang"], selesai: ["gray", "Selesai"] };

// Daftar penerbangan: yang akan datang paling atas (urut jam), lalu yang sudah lewat
export function BandaraJadwal({ d, now }) {
  const rows = [...d.penerbangan].sort((a, b) => {
    const ta = Date.parse(a.berangkat_at), tb = Date.parse(b.berangkat_at), fa = ta >= now - 42000, fb = tb >= now - 42000;
    return fa !== fb ? (fa ? -1 : 1) : fa ? ta - tb : tb - ta;
  });
  if (!rows.length) return <p data-testid="bandara-jadwal-kosong" style={{ margin: 0, fontSize: 13, color: D.sub }}>Belum ada penerbangan. Begitu ada komentar “{d.kata_pemicu}” di IG (atau pendatang ditambah), jadwal muncul di sini.</p>;
  return (
    <div data-testid="bandara-jadwal" style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 330, overflowY: "auto", paddingRight: 2 }}>
      {rows.map(f => {
        const t = Date.parse(f.berangkat_at) - now, [tone, label] = STATUS[f.status] || ["gray", f.status];
        const live = -t >= 0 && -t < 42000;
        return (
          <div key={f.id} data-testid={`bandara-penerbangan-${f.nomor}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 14, background: live ? D.blueSoft : D.cream, fontSize: 12.5 }}>
            <b style={{ color: D.blue, fontVariantNumeric: "tabular-nums", width: 58 }}>{f.nomor}</b>
            <b style={{ color: D.ink, width: 72 }}>{f.berangkat_wib} WIB</b>
            <span style={{ color: D.sub, width: 64, fontVariantNumeric: "tabular-nums" }}>{t > 0 ? hitungMundur(t) : live ? "LIVE" : "—"}</span>
            <span style={{ flex: 1, minWidth: 0, display: "flex", gap: 4, flexWrap: "wrap" }}>
              {f.penumpang.slice(0, 3).map(p => (
                <span key={p.username} title={`@${p.username} → ${KOTA(p.kota)}`} style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 99, background: "#fff", fontSize: 11, fontWeight: 700, color: D.ink }}>
                  <span style={{ width: 8, height: 8, borderRadius: 99, background: p.warna || D.gray, flex: "none" }} />@{p.username}<span style={{ color: D.sub, fontWeight: 600 }}>· {KOTA(p.kota)}</span>
                </span>
              ))}
              {f.penumpang.length > 3 && <span style={{ fontSize: 11, color: D.sub, fontWeight: 700, alignSelf: "center" }} title={f.penumpang.slice(3).map(p => `@${p.username}`).join(", ")}>+{f.penumpang.length - 3}</span>}
            </span>
            <span style={{ color: D.sub, fontSize: 11, flex: "none" }}>{f.penumpang.length}/{f.muat}</span>
            <Chip tone={live ? "green" : tone}>{live ? "Terbang" : label}</Chip>
          </div>
        );
      })}
    </div>
  );
}
